import { SelectStatementColumn } from './../../../models/select-statement-column.model';
import { Title } from '@angular/platform-browser';
import { Component, OnInit,  ViewChild, inject } from "@angular/core";
import { ForecastDetailedPostingsChartDto } from "./forecast-detailed-postings.models";
import { ActivatedRoute } from "@angular/router";
import { ColumnType } from "src/app/enums/columnType";
import { DetailedPostingsManualDto } from "src/app/models/detailed-postings-manual-dto";
import { LoadService } from "src/app/services/load.service";

import { ForecastService } from "../forecast.service";
import { EsoService } from "../../eso/eso.service";
import { InfoBoxService } from "src/app/services/info-box.service";
import { ListService } from "src/app/services/list.service";
import { ListElementEnum } from "src/app/enums/listElementEnum";
import { FileExportService } from 'src/app/common/file-export-service';
import { DevTooltipCustComponent } from 'src/app/widgets/dev-tooltip-cust/dev-tooltip-cust.component';
import { DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import { UtilsService } from 'src/app/services/utils.service';
import { GlobalConstants } from 'src/app/common/global-constants';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { ItemClickEvent } from 'devextreme/ui/autocomplete_types';
import { Location } from '@angular/common';

@Component({
    templateUrl: "./forecast-detailed-postings.component.html",
    styleUrls: ['./forecast-detailed-postings.component.scss'],
    standalone: false
})
export class ForecastDetailedPostingsComponent implements OnInit {

	private readonly _componentTitle = "Forecast Detailed Postings";
	private readonly _idQueryParamName = "id";

	private _location: Location = inject(Location);

	private _selectedProductId: string = null;
	public get selectedProductId(): string {
		return this._selectedProductId;
	}
	public set selectedProductId(value: string) {
		this._selectedProductId = value;

		if (this._selectedProductId) {
			const url = `forecast/detailed-postings?${this._idQueryParamName}=${this._selectedProductId}`;
			this._location.replaceState(url);

			this.getData(this._selectedProductId);
		}
	}

	hasDirty = false;
	compactMode = false;
	showInfoPopup = false;
	infoPopupMessage = '';
	infPopupTitle = '';

	selectedEsoProduct = '';
	selectedPage = '';
	ForecastChartCaption;
	chartData: ForecastDetailedPostingsChartDto[] = [];
	autocompleteSource: string[] = [];
	gridColumns: SelectStatementColumn[] = [];
	gridData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];

	editableColumns = {
		AutoCleanApproved: ColumnType.YesNo,
		ApplyEso: ColumnType.YesNo,
		ApplyForecast: ColumnType.YesNo,
		Reviewed: ColumnType.YesNo,
		Comment: ColumnType.Text,
		ManualClean: ColumnType.Number,
	};

	yesNoDataSource: { display: string; value: boolean }[];
	@ViewChild("forecastDetailPostingChart", { static: false }) dxForecastDetailPostingChart: DxChartComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	constructor(
		private forecastService: ForecastService,
		private esoService: EsoService,
		private route: ActivatedRoute,
		private listService: ListService,
		private loadService: LoadService,
		private infoBoxService: InfoBoxService,
		private titleService: Title,
		private fileExportService: FileExportService,
	) { }

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.route.queryParamMap.subscribe(
			{
				next: (queryParams) => {
					this.selectedProductId = queryParams.get(this._idQueryParamName);
				}
			}
		);

		this.forecastService.GetForecastObjectClientIds().subscribe(
			{
				next: (response) => {
					this.autocompleteSource = response;

					if (!this.selectedProductId && this.autocompleteSource.length > 0) {
						this.selectedProductId = this.autocompleteSource[0];
					}
				}
			}
		);

		this.forecastService.SelectCaptionChart().subscribe((res) => {
			this.ForecastChartCaption = res;
			this.LoadChartSeries();
			console.log(this.ForecastChartCaption);
		});

		this.listService.GetListElements(ListElementEnum.YesNo).subscribe((res) => {
			this.yesNoDataSource = res.map((obj) => ({
				display: obj.listElement,
				value: obj.listElement === "Yes",
			}));
		});

		this.WebSettingsPivot();
		this.GetSettingsData();
	}
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastDetailedPostingslist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	onProductIdChange(evt: ItemClickEvent) {
		let selectedProductId = "";
		if (evt != null && evt.itemData && evt.itemData.productId) {
			selectedProductId = evt.itemData.productId;
		}
		else if (evt != null && evt.itemData) {
			selectedProductId = evt.itemData;
		}
		if (selectedProductId != "") {
			this.selectedProductId = selectedProductId;
		}
	}

	canEdit(column: string) {
		return typeof this.editableColumns[column] === "number";
	}

	showYesNoDropdown(column: string) {
		return this.editableColumns[column] === ColumnType.YesNo;
	}

	onDataGridCellPrepared(e) {
	}

	onSaveChanges() {
		const changedItems = this.gridData
			.filter((i) => i.IsDirty)
			.map<DetailedPostingsManualDto>((item) => ({
				autoCleanApproved: item.AutoCleanApproved as boolean,
				applyEso: item.ApplyEso as boolean,
				applyForecast: item.ApplyForecast as boolean,
				reviewed: item.Reviewed as boolean,
				comment: item.Comment as string,
				manualClean: item.ManualClean as number,
				dateId: item.DateId as number,
				transactionObjectId: item.TransactionObjectId as number,
			}));

		if (changedItems.length > 0) {
			this.esoService
				.SaveDetailedPostingsManuals(changedItems)
				.subscribe((res) => {
					this.infoBoxService.show({
						message: "Data has been successfully saved!",
					});
					this.getData(this.selectedProductId);
				});
		}
	}

	onReset() {
		this.getGridData(this.selectedProductId);
	}

	onRowUpdated(event: any) {
		if (event.key.TransactionObjectId && event.key.DateId) {
			this.hasDirty = true;
			this.gridData = this.gridData.map((item) =>
				item.TransactionObjectId === event.key.TransactionObjectId &&
					item.DateId === event.key.DateId
					? { ...item, IsDirty: true }
					: item
			);
		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-detailed', JSON.stringify(this.dataGrid.instance.state()));
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift(
			{
				location: "before",
				template: "gridActions",
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			},
			{
				location: 'before',
				template: 'saveButtonTemplate'
			},
			{
				location: 'before',
				template: 'undoButtonTemplate'
			},
		);
	}

	private getData(productId: string) {
		this.getGridData(productId);

		this.forecastService
			.GetDetailedPostingsChartData(productId)
			.subscribe((chartData) => {
				this.LoadChartSeries();
				this.chartData = chartData;
			});
	}

	LoadChartSeries() {
		if (this.ForecastChartCaption != null && this.ForecastChartCaption.length > 0) {
			if (this.dxForecastDetailPostingChart != null && this.dxForecastDetailPostingChart.series != null
				&& Array.isArray(this.dxForecastDetailPostingChart.series) && this.dxForecastDetailPostingChart.series.length > 0) {
				for (let index = 0; index < this.dxForecastDetailPostingChart.series.length; index++) {
					this.ForecastChartCaption.forEach(itemchrt => {
						if (this.dxForecastDetailPostingChart.series[index].valueField != null
							&& itemchrt.isVisible != null && (this.dxForecastDetailPostingChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
								|| this.dxForecastDetailPostingChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
						) {
							this.dxForecastDetailPostingChart.series[index].visible = itemchrt.isVisible;
						}
					});
				}
			}
		}
	}

	private getGridData(productId: string) {
		this.hasDirty = false;
		this.forecastService
			.GetDetailedPostingsData(productId)
			.subscribe((response: { columns: SelectStatementColumn[], data: any[] }) => {
				const { columns, data } = response;
				this.gridColumns = columns;
				this.gridData = data;
			});
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotForecastDetailPosting").subscribe(result => {
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastDetailPosting != null
				&& result[0].defaultSelectionTooltipForecastDetailPosting.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastDetailPosting != null
				&& result[0].enableDisableTooltipForecastDetailPosting.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Year-Month", "", "");
	}
	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'detailposting', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

}
